const ADMIN_USER_UUIDS = [
  'f0f45792-63a5-47fb-92b0-52d812ff6e6e', // User#1 - tig****
  'e0c79ebf-099a-4f7e-9a50-68048c00bf82', // User#2 - kjy***
  '1065fd7e-6cca-4b2f-b7c7-79c66a5bf785', // User#3 - hor***
  'ca8fcbee-2065-43c7-9eba-b068d1c9f760', // User#12- jykei*****
  '7f1b2d55-b9ae-4cf7-bac7-4dfe1dcc2fef', // User#15 - prk****
  'a120b297-32c4-482b-b97b-0f00f91ab92e', // User#32140 - poca****
  'fbd1c0b8-5125-450f-a40c-f3af4f562e55' // User#72009 - kjy**
];

export function isAdminUser(userId) {
  if (process.env.REACT_APP_DEPLOY_ENV !== 'production') {
    return true;
  }
  return ADMIN_USER_UUIDS.includes(userId);
}
